import { createSlice } from "@reduxjs/toolkit";
import { deleteCouponsAPI } from "../../api/coupons";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const deleteCouponsSlice = createSlice({
  name: "deleteCoupons",
  initialState: data,
  reducers: {
   deleteCouponsSlice(state) {
      state.isLoading = true;
    },
   deleteCouponsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteCouponsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteCouponsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const deleteCouponsHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(deleteCouponsAction.deleteCouponsSlice());
    const response: any = await deleteCouponsAPI(id);
    
    dispatch(deleteCouponsAction.deleteCouponsSliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteCouponsAction.deleteCouponsSliceFailure(e?.response?.data));
  }
};
export default deleteCouponsSlice.reducer;
export const deleteCouponsAction = deleteCouponsSlice.actions;
